import { render, staticRenderFns } from "./Buero.vue?vue&type=template&id=21f5222e&scoped=true&"
import script from "./Buero.vue?vue&type=script&lang=js&"
export * from "./Buero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f5222e",
  null
  
)

export default component.exports